"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TocOptions = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const Slider_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Slider");
const Checkbox_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Checkbox");
const Separator_1 = require("@jsonjoy.com/ui/lib/3-list-item/Separator");
const FormRow_1 = require("@jsonjoy.com/ui/lib/3-list-item/FormRow");
const state_1 = require("./state");
const use_t_1 = require("use-t");
const blockClass = (0, nano_theme_1.rule)({
    bxz: 'border-box',
    d: 'flex',
    fld: 'column',
    gap: '12px',
    maxW: '420px',
});
const stopInputKeyDown = (event) => {
    event.stopPropagation();
};
const TocOptions = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, state_1.useTocOptionsState)();
    const caption = state.caption.use();
    const maxLevel = state.maxLevel.use();
    const includeTitle = state.includeTitle.use();
    const numbered = state.numbered.use();
    return (React.createElement("div", { className: blockClass },
        React.createElement(Input_1.Input, { type: "text", value: caption, label: t('Caption (optional)'), placeholder: t('Table of contents'), onChange: state.setCaption, onKeyDown: stopInputKeyDown, onEnter: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.apply();
            }, onEsc: (event) => {
                event.preventDefault();
                event.stopPropagation();
                state.cancel();
            } }),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Max heading level'), descriptionAbove: true, description: t('Deepest heading level to include in the contents.') },
            React.createElement(Slider_1.Slider, { value: maxLevel, min: 1, max: 6, step: 1, showValue: true, onChange: state.setMaxLevel })),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Include title'), description: t('Show the document title at the top of the contents.'), right: true },
            React.createElement("div", { style: { width: 60, marginTop: -8 } },
                React.createElement(Checkbox_1.Checkbox, { on: includeTitle, onChange: () => state.setIncludeTitle(!includeTitle) }))),
        React.createElement(Separator_1.Separator, null),
        React.createElement(FormRow_1.FormRow, { title: t('Numbered'), description: t('Prefix each entry with its hierarchical number (1., 1.1., …).'), right: true },
            React.createElement("div", { style: { width: 60, marginTop: -8 } },
                React.createElement(Checkbox_1.Checkbox, { on: numbered, onChange: () => state.setNumbered(!numbered) })))));
};
exports.TocOptions = TocOptions;
